import React, { Component } from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import { createStructuredSelector } from "reselect";

import stickyfiller from '../utils/stickyfiller';
import { downloadPDF, downloadClientPDF } from '../actions/save-to-pdf';
import { downloadTicket } from '../actions/get-trade-ticket';
import logoStore from '../actions/query-api/logo-store'

import { dataSelector } from "../Report/selectors";
import Watermark from '../components/Watermark';

import ClientPDFModal from './ClientPDFModal'

import './style.css'

class Nav extends Component {

  constructor(props){
    super(props);
    this.state = {
      menuOpen: false
    }
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  componentWillUpdate(nextProps){
    if(this.state.menuOpen && (nextProps.pdfStatus === 'pending' || nextProps.clientPdf.status === 'pending')){
      this.setState({ menuOpen: false })
    }
  }

  toggleMenu(){
    this.setState({
      menuOpen: !this.state.menuOpen && this.props.pdfStatus === "export"
    })
  }

  render(){
    let { 
      version,
      children,
      clearAnalysis,
      pdfStatus,
      ticketStatus,
      TEXT,
      features,
    } = this.props;
    let { downloadTicket, downloadPDF } = this.props;

    return (
      <nav ref={stickyfiller}>
        <div className="version">{"V"+version}</div>
        
        { (window.portfolioMapper && window.portfolioMapper.logoURL)? 
        <Watermark page='report' logoURL={window.portfolioMapper.logoURL}/>
        : <div className="white-label upper-right-report-logo"></div>}
        
        <div className="actions">
          <PdfMenu 
            toggleMenu={this.toggleMenu}
            {...this.state}
            {...this.props} />
          <ul>            
            <li className={Classnames("action", "pdf", pdfStatus)}
              onClick={() => features.clientPDF ? this.toggleMenu() : downloadPDF()}>
              {pdfStatus === "pending" || pdfStatus === "unsent"
                ? TEXT.fetchingpdfBreadcrumbsLabel
                : pdfStatus === "unavailable"
                  ? TEXT.pdfUnavailableBreadcrumbsLabel
                  : TEXT.exportpdfBreadcrumbsLabel}
            </li>
            {!features.tradeTicket ? null : 
            <li 
              className={Classnames("action","ticket",ticketStatus)}
              onClick={downloadTicket}>
              {ticketStatus === "pending" || ticketStatus === "unsent"
                ? TEXT.fetchingTradeTicketBreadcrumbsLabel
                : pdfStatus === "unavailable"
                  ? TEXT.tradeTicketUnavailableBreadcrumbsLabel
                  : TEXT.exportTradeTicketBreadcrumbsLabel}
            </li>}
            <li className="action edit" onClick={clearAnalysis}>
              <button onClick={clearAnalysis}>
                <span>{TEXT.editPortfolioBreadcrumbsLabel}</span>
              </button>
              
            </li>
          </ul>
        </div>

        <div className="sections">{children}</div>
      </nav>)
  }
};

const PdfMenu = props => (
  <div className={"pdf-menu " + (!props.menuOpen && "hidden")}>
    <div 
      onClick={props.toggleMenu}
      className="action export-breadcrumbs">{props.TEXT.exportpdfBreadcrumbsLabel}</div>
    <div 
      onClick={props.downloadPDF}
      className="item">{props.TEXT.financialProfessionalPDFBreadcrumbsLabel}</div>
    <div 
      onClick={() => {
        if(props.clientPdf.status === "export"){
          props.downloadClientPDF()
        } else {
          props.openClientPDFModal(
            <ClientPDFModal { ...props } />)
        }
      }}
      className="item">{props.TEXT.clientReadyPDFBreadcrumbsLabel}</div>
  </div>
)

const mapStateToProps = createStructuredSelector({
  version: state => state.version,
  pdfStatus: state => state.pdfStatus,
  ticketStatus: state => state.ticketStatus,
  keyMetrics: state => state.keyMetrics,
  data: dataSelector,
  clientPdf: state => state.clientPdf,
  TEXT: state => state.complianceText,
  features: state => state.features,
});

const mapDispatchToProps = dispatch => ({
  clearAnalysis: () => dispatch({ type: 'CLEAR_ANALYSIS' }),
  downloadPDF: () => dispatch(downloadPDF),
  downloadClientPDF: () => dispatch(downloadClientPDF),
  downloadTicket: () => dispatch(downloadTicket),
  openClientPDFModal: message => dispatch({
    type: 'DIALOG',
    message: message,
    wide: true,
    buttons: [
      { label: 'Cancel' },
      { label: 'Export PDF', callback: () => {
        dispatch({ type: "LOADING" })
        dispatch({ type: "SET_CLIENT_PDF", key: "status", value: "pending" })

        // ensure PDF has access to logo, then get client PDF
        dispatch(logoStore('POST', () => {
          dispatch({ type: "SET_PDF_STATUS", status: "unsent" });        
        }))

      }},
    ],
  })
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// ./src/Nav/index.js